import $http from '@/plugins/axios'
import { NotificationType, NotificationItemSearchType } from '@/utils/enums/notification-enums'

const RESOURCE_NAME = '/admin/notifications'

export default {
  async getAll (params) {
    let res = await $http().get(`${RESOURCE_NAME}`, { params: params })
    return res
  },

  async getMetrics (params) {
    if (!params) {
      params = {
        keyword: '',
        searchType: NotificationItemSearchType.Title
      }
    }
    let res = await $http().get(`${RESOURCE_NAME}/metrics`, { params: params })
    return res
  },

  async getNewDataDiscrepanciesCount () {
    let res = await this.getMetrics()
    return res.countByTypeAndState.Item.New + res.countByTypeAndState.Contributor.New
  },

  async getAzureAlertMetrics () {
    let res = await $http().get(`${RESOURCE_NAME}/azure-alert/metrics`)
    return res
  },

  async updateNotification (payload) {
    let typeSpecificRoute = ''
    switch (payload.type) {
    case NotificationType.Item:
      typeSpecificRoute = '/similar-item'
      break
    case NotificationType.Contributor:
      typeSpecificRoute = '/similar-contributor'
      break
    case NotificationType.PricingError:
      typeSpecificRoute = '/pricing-error'
      break
    case NotificationType.AzureAlert:
      typeSpecificRoute = '/azure-alert'
      break
    }
    await $http().put(`${RESOURCE_NAME}${typeSpecificRoute}/${payload.id}?type=${payload.type}`, { ...payload })
  },

  async dismissAll (ids, type) {
    let typeSpecificRoute = ''
    switch (type) {
    case NotificationType.Item:
      typeSpecificRoute = '/similar-item'
      break
    case NotificationType.Contributor:
      typeSpecificRoute = '/similar-contributor'
      break
    case NotificationType.PricingError:
      typeSpecificRoute = '/pricing-error'
      break
    case NotificationType.AzureAlert:
      typeSpecificRoute = '/azure-alert'
      break
    }
    await $http().patch(`${RESOURCE_NAME}${typeSpecificRoute}/dismiss-many`, ids)
  }
}
